export const ACTIVITY_TYPE = {
    ALL: 'allActivities',
    AT_HOME: 'atHome',
    ON_THE_GO: 'onTheGo',
};

export default ACTIVITY_TYPE;



// WEBPACK FOOTER //
// ./src/constants/activityTypes.js